import request from '@/plugin/axios'

// 保险台账接口封装（接口前缀 /tms/tmsinsuranceledger）
// 统一返回 { code, msg, data }，code=0 成功、code=1 失败。
// 审核状态 auditStatus："0"未审核、"1"已审核；终审状态 finalAuditStatus："0"未终审、"1"已终审。

/**
 * 分页查询（current、size 必传，模糊查询字段放 inputLike：projectName、insuranceCompany、accidentNo）
 */
export function fetchList (query) {
  return request({
    url: '/tms/tmsinsuranceledger/page',
    method: 'post',
    data: query
  })
}

/**
 * 按 ID 查询详情
 */
export function getObj (id) {
  return request({
    url: '/tms/tmsinsuranceledger/' + id,
    method: 'get'
  })
}

/**
 * 新增时按事故单号查询回填数据（只读，不新增不修改台账）
 */
export function getAccidentData (accidentNo) {
  return request({
    url: '/tms/tmsinsuranceledger/getAccidentData',
    method: 'get',
    params: { accidentNo: accidentNo }
  })
}

/**
 * 新增（不传 id；后端初始化 auditStatus/finalAuditStatus 为 "0"、insuranceStatus 为 未完结）
 */
export function addObj (obj) {
  return request({
    url: '/tms/tmsinsuranceledger',
    method: 'post',
    data: obj
  })
}

/**
 * 修改（必带 id；已审核或已终审时后端会拒绝）
 */
export function putObj (obj) {
  return request({
    url: '/tms/tmsinsuranceledger',
    method: 'put',
    data: obj
  })
}

/**
 * 批量删除（params.ids 英文逗号分隔，如 1,2,3；已审核/已终审的台账不能删除）
 */
export function delObjs (obj) {
  return request({
    url: '/tms/tmsinsuranceledger/delbyids',
    method: 'post',
    params: obj
  })
}

/**
 * 审核 / 反审核 / 终审 / 反终审
 * @param {String} type audit审核 / auditundo反审核 / auditdoc终审 / auditdocundo反终审
 * @param {String|Number} ids 记录id，英文逗号分隔
 */
export function reviewObj (type, ids) {
  return request({
    url: '/tms/tmsinsuranceledger/' + type,
    method: 'post',
    params: { ids: ids }
  })
}

/**
 * 保险单证资料 / 保险回款核销 上传保存（由 d2-uploadAli 公用组件调用）
 * objectNo = INSURANCE_LEDGER_台账id；itemType 直接传中文类型（如 事故认定书）
 */
export function uploadInsuranceFile (obj) {
  return request({
    url: '/tms/ossobject/tmsInsuranceLedgerTrackUpload',
    method: 'post',
    data: obj
  })
}

/**
 * 查询跟踪记录列表（参数 ledgerId，按 trackTime 倒序返回）
 */
export function fetchTrackList (ledgerId) {
  return request({
    url: '/tms/tmsinsuranceledger/getInsuranceTrackList',
    method: 'get',
    params: { ledgerId: ledgerId }
  })
}

/**
 * 新增跟踪记录（ledgerId、trackContent、trackTime、category、nodeFollowPerson）
 * 成功后后台同步更新台账 进展/最新进展/跟踪时间/大类/节点跟进人
 */
export function addTrack (obj) {
  return request({
    url: '/tms/tmsinsuranceledger/addInsuranceTrack',
    method: 'post',
    data: obj
  })
}
